import { useRateLimit } from '@/context/rate-limit-context';
import { AlertCircle, Clock, X } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export function RateLimitBanner() {
  const { rateLimitInfo, clearRateLimitInfo } = useRateLimit();

  if (!rateLimitInfo) return null;

  return (
    <div className='fixed top-0 left-0 right-0 z-50 animate-in slide-in-from-top'>
      <Alert className='rounded-none border-x-0 border-t-0 border-b-2 border-yellow-500 bg-yellow-50 dark:bg-yellow-950/20'>
        <div className='flex items-start gap-3'>
          <div className='flex items-center gap-2 flex-1'>
            {rateLimitInfo.isBankRateLimit ? (
              <Clock className='h-5 w-5 text-yellow-600' />
            ) : (
              <AlertCircle className='h-5 w-5 text-yellow-600' />
            )}
            <div className='flex-1'>
              <AlertTitle className='text-yellow-800 dark:text-yellow-200 mb-1'>
                {rateLimitInfo.isBankRateLimit
                  ? 'Bank Rate Limit Reached'
                  : 'API Rate Limit Reached'}
              </AlertTitle>
              <AlertDescription className='text-yellow-700 dark:text-yellow-300 text-sm'>
                {rateLimitInfo.message}
                {rateLimitInfo.waitTimeHours && (
                  <span className='font-semibold ml-1'>
                    Please try again in approximately{' '}
                    {rateLimitInfo.waitTimeHours} hour
                    {rateLimitInfo.waitTimeHours > 1 ? 's' : ''}.
                  </span>
                )}
              </AlertDescription>
            </div>
          </div>
          <Button
            variant='ghost'
            size='icon'
            className='h-6 w-6 text-yellow-600 hover:text-yellow-800 hover:bg-yellow-100 dark:hover:bg-yellow-900/40'
            onClick={clearRateLimitInfo}
            aria-label='Dismiss notification'
          >
            <X className='h-4 w-4' />
          </Button>
        </div>
      </Alert>
    </div>
  );
}
